import { settingConstants } from "../actions/constants/settingConstant";

type SettingState = {
	items: any[];
};

const initialSetting: SettingState = {
	items: [],
};

const settingData = (state = initialSetting, action: any) => {
	switch (action.type) {
		case settingConstants.Setting_Get_Request:
			return {
				...state,
				isLoading: true,
				isError: false,
				isSuccess: false,
			};
		case settingConstants.Setting_Get_Success:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isListSuccess: true,
				items: action.payload,
			};
		case settingConstants.Setting_Get_Failure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isListSuccess: true,
				status: action.payload,
			};

		case settingConstants.SettingStatusUpdateRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isUpdateStatus: false,
			};
		case settingConstants.SettingStatusUpdateSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isUpdateStatus: true,
				status: action.payload.status,
			};
		case settingConstants.SettingStatusUpdateFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isUpdateStatus: true,
				status: action.payload.status,
			};

		case settingConstants.SettingContentUpdateRequest:
			return {
				...state,
				isLoading: true,
				isSuccess: false,
				isError: false,
				isFormSubmit: true,
				isUpdateContent: false,
			};
		case settingConstants.SettingContentUpdateSuccess:
			return {
				...state,
				isLoading: false,
				isSuccess: true,
				isError: false,
				isUpdateContent: true,
				isFormSubmit: false,
				status: action.payload.status,
			};
		case settingConstants.SettingContentUpdateFailure:
			return {
				...state,
				isLoading: false,
				isSuccess: false,
				isError: true,
				isUpdateContent: true,
				isFormSubmit: false,
				status: action.payload,
			};

		case settingConstants.GetSettingContentRequest:
			return {
				...state,
				showLoading: true,
				isError: false,
				isSuccess: false,
			};
		case settingConstants.GetSettingContentSuccess:
			return {
				...state,
				showLoading: false,
				isSuccess: true,
				isError: false,
				isDetailSuccess: true,
				settingContent: action.payload,
			};
		case settingConstants.GetSettingContentFailure:
			return {
				...state,
				showLoading: false,
				isSuccess: false,
				isError: true,
				isDetailSuccess: true,
				status: action.payload,
			};

		default:
			return state;
	}
};

export default settingData;
